import { WorkspaceItem } from '../../../core/submission/models/workspaceitem.model';
import { SearchResult } from '../../search/models/search-result.model';

/**
 * Represents a search result object of a WorkspaceItem object
 */
export class WorkspaceItemSearchResult extends SearchResult<WorkspaceItem> {
}
